import React from 'react';
import '../styles/Footer.css'; // Importando o CSS

function Footer() {
  return (
    <footer>
      <p>&copy; 2025 Palha Italiana. Todos os direitos reservados.</p>
    </footer>
  );
}

export default Footer;
